<div class="compare">

    <!-- ---- Bar ---- -->
    <div class="compare-bar">
        <button type="button" class="compare-exit" (click)="exit.emit()">
            <mat-icon>arrow_back</mat-icon>
            Exit compare
        </button>

        <div class="compare-title">
            <span class="compare-label">Compare versions</span>
            <span class="compare-file" [matTooltip]="fileName">{{ fileName }}</span>
        </div>

        <span class="compare-spacer"></span>

        <button type="button" class="compare-toggle" [class.is-on]="linkedScroll" [attr.aria-pressed]="linkedScroll"
            matTooltip="Keep both versions at the same position while scrolling" (click)="toggleLinkedScroll()">
            <mat-icon>{{ linkedScroll ? 'link' : 'link_off' }}</mat-icon>
            Linked scroll
        </button>

        <button type="button" class="compare-swap" matTooltip="Swap sides" aria-label="Swap sides"
            (click)="swapSides()">
            <mat-icon>swap_horiz</mat-icon>
        </button>

        <div class="zoom-control">
            <button type="button" aria-label="Zoom out" [disabled]="!canZoomOut" (click)="zoomOut()">−</button>
            <span class="zoom-value">{{ zoom }}%</span>
            <button type="button" aria-label="Zoom in" [disabled]="!canZoomIn" (click)="zoomIn()">+</button>
        </div>
    </div>

    <!-- ---- Panes ---- -->
    <div class="compare-panes">
        @for (pane of panes; track pane.side) {
        <section class="compare-pane" [class.is-current]="pane.version.isCurrent">
            <div class="compare-pane-head">
                <mat-form-field class="field-select compare-select" subscriptSizing="dynamic">
                    <mat-select [value]="pane.version.attachmentId" (selectionChange)="choose(pane.side, $event.value)"
                        [aria-label]="(pane.side === 'left' ? 'Left' : 'Right') + ' version'">
                        @for (version of versions; track version.attachmentId) {
                        <mat-option [value]="version.attachmentId"
                            [disabled]="version.attachmentId === otherId(pane.side)">
                            v{{ version.version }}{{ version.isCurrent ? ' · Current' : '' }}
                        </mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <span class="compare-tag" [class.is-current]="pane.version.isCurrent">
                    {{ pane.version.isCurrent ? 'Current' : 'Earlier version' }}
                </span>

                @if (pane.openPins) {
                <span class="compare-pins" matTooltip="Pinned comments on this version still open">
                    <mat-icon>push_pin</mat-icon>
                    {{ pane.openPins }} open
                </span>
                }
            </div>

            <p class="compare-pane-meta">
                <span class="compare-pane-name">{{ pane.version.fileName }}</span>
                @if (pane.version.uploadedOn) {
                <span>· uploaded {{ pane.version.uploadedOn }}</span>
                }
            </p>

            <div #paneScroll class="compare-scroll" (scroll)="onPaneScroll(pane.side)">
                @if (pane.version.pinnable) {
                <app-pin-viewer [src]="pane.version.url" [fileName]="pane.version.fileName"
                    [kind]="pane.version.kind" [zoom]="zoom" [pins]="pane.pins" [readOnly]="true"></app-pin-viewer>
                } @else if (pane.version.kind === 'video') {
                <div class="media-plate is-video">
                    <video [src]="pane.version.url" controls preload="metadata"></video>
                </div>
                } @else {
                <div class="media-frame">
                    <div class="media-doc" [attr.data-tone]="pane.version.tone">
                        <span class="media-doc-disc">
                            <mat-icon>{{ pane.version.icon }}</mat-icon>
                        </span>
                        <p class="media-doc-name">{{ pane.version.fileName }}</p>
                        <p class="media-doc-meta">{{ pane.version.label }}</p>
                        <p class="media-note">This format cannot be previewed here. Open the file to compare it.</p>
                        <a class="media-doc-open" [href]="pane.version.url" target="_blank" rel="noopener noreferrer">
                            <mat-icon>open_in_new</mat-icon> Open file
                        </a>
                    </div>
                </div>
                }
            </div>
        </section>
        }
    </div>
</div>
